import React, { useEffect, useState } from 'react';
import { get, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { digitalVideoPlayer } from '../../../../actions/digitalClassActions';
import Grid from '@material-ui/core/Grid';
import './styles.scss';
import VideoPlayer from '../../../../components/VideoPlayer';
import ModuleCard from './components/ModuleCard';
import { Link, useParams } from 'react-router-dom';
import '../../../../css/styles.scss';
import DigitalClassroomLayout from '../DigitalClassLayout';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import LoadingSkeleton from '../../../../components/LoadingSkeleton';

//images
/*
const getPage = () => {
  let location = useLocation();
  //let history = useHistory();
  let pathData = location.pathname.split('/');
  console.log(pathData,'path')

  if (pathData[0] ==='digital-classroom')
  return 'digital-classroom';
  else
return '';
};*/

export default function DigitalLectureLayout() {
  // const { params } = props.match;
  // console.log('params ', params);
  let { unique, module } = useParams();
  //let history = useHistory();
  //let uniqueCodePara;
  // State
  const [moduleCode, setModuleCode] = useState('');
  const [uniqueCode, setUniqueCode] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  // const [isFetching, setIsFetching] = useState(false);
  // const [moduleIndex, setModuleIndex] = useState(0);
  // Redux Store
  const dispatch = useDispatch();
  const loginData = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', {})
  );
  const videoData = useSelector((state) =>
    get(state, 'digitalClassReducer.videoData', {})
  );

  let classTitle, subject;
  if (videoData) {
    classTitle = videoData.ClassTitle;
    subject = videoData.SubjectName;
    // classNo = videoData.ClassNo;
  }
  useEffect(() => {
    setUniqueCode(unique);
    setModuleCode(module);
  });

  useEffect(() => {
    if (moduleCode) {
      (Object.keys(videoData).length == 0) && setIsVideoLoading(true);
      digitalVideoPlayer(loginData, uniqueCode, moduleCode, dispatch).then(
        () => {
          setIsVideoLoading(false);
        }
      );
    } else {
      setIsVideoLoading(true);
      digitalVideoPlayer(loginData, unique, moduleCode, dispatch).then(() => {
        setIsVideoLoading(false);
      });
      setSelectedIndex(0);
    }
  }, [uniqueCode, unique, moduleCode]);

  const moduleHandler = (unique, module) => {
    setUniqueCode(unique);
    setModuleCode(module);
  };

  const populateModuleData = () => {
    const moduleData = [];
    get(videoData, 'listClass', []).map((data, index) => {
      return moduleData.push(
        <Link
          to={'/digital-classroom/' + data.UniqueCode + '/' + data.ModuleCode}
          key={index}
        >
          <ModuleCard
            subject={subject}
            subjectTitle={classTitle}
            module={data.ModuleNo}
            selected={index === selectedIndex}
            handler={() => {
              setSelectedIndex(index);
              moduleHandler(data.UniqueCode, data.ModuleCode);
            }}
          />
        </Link>
      );
    });
    return moduleData;
  };

  const populateClassMaterial = () => {
    const classData = [];
    get(videoData, 'listNotes', []).map((data, index) => {
      return classData.push(
        <li key={index}>
          <a
            href={data.Value}
            target="_blank"
            rel="noopener noreferrer"
            className="text"
          >
            {data.Text}
          </a>
        </li>
      );
    });
    return classData;
  };

  // const populatedigitalClassList = () => {
  //   let list = [];
  //   if (!isEmpty(digitalClassListData))
  //     digitalClassListData.map((data, index) => {
  //       let classList = [];
  //       data.listClass.map((classes, classIndex) => {
  //         let uniquekey = `${index}${classIndex}`;
  //         classList.push(
  //           <Grid item xs={6} sm={3} key={index}>
  //             <Link to={'/digital-classroom/' + classes.UniqueCode}>
  //               <TimerCard
  //                 key={uniquekey}
  //                 // uniqueKey={uniquekey}
  //                 subject={classes.SubjectName}
  //                 dateTime={`${dateFormat(data.ClassDate)} at ${
  //                   classes.ClassTime
  //                 }`}
  //                 topic={classes.ModuleNo}
  //                 handler={val => handler(classes.Expiry)}
  //                 start={classes.RemainingTime < 0 ? 'EXPIREs IN' : 'STARTs IN'}
  //                 initialTime={
  //                   classes.RemainingTime < 0
  //                     ? classes.Expiry * 1000
  //                     : classes.RemainingTime * 1000
  //                 }
  //               />
  //             </Link>
  //           </Grid>
  //         );
  //       });
  //       return list.push(
  //         <Grid container spacing={2}>
  //           {classList}
  //         </Grid>
  //       );
  //     });
  //   return list;
  // };
  //const url = getPage()
  //console.log('url',url)
  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={8}>
          {isVideoLoading ? (
            <LoadingSkeleton type="image" height="400px" />
          ) : (
            <div className="video-container">
              <Link to={`/digital-classroom`} className="back-btn">
                <ArrowBackIcon /> Back
              </Link>
              <div className="video-header">
                <div className="flex-row flex-space-between">
                  <div className="class-text">{subject}</div>
                </div>
                <div className="video-header-title">
                  <h3 className="topic-text">{classTitle}</h3>
                </div>
              </div>
              <div className="video-player">
                <VideoPlayer source={videoData.ClassURL} autoPlay={false} />
              </div>
            </div>
          )}
          <div className="info-text">
            <span className="imp-text">Important:</span>
            Above video classes are copyrighted and copyright of these classes
            is reserved with ALLEN. Capturing, downloading and sharing of these
            classes is a criminal and punishable offense. All viewers are
            advised to refrain in involving any such activity.
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <div className="video-right-panel">
            {isVideoLoading ? (
              <LoadingSkeleton type="moduleList" />
            ) : (
              <PerfectScrollbar>
                {!isEmpty(videoData) &&
                  videoData.listClass &&
                  populateModuleData()}
              </PerfectScrollbar>
            )}
          </div>
        </Grid>
      </Grid>
      {isVideoLoading ? (
        <LoadingSkeleton type="card" />
      ) : (
        !isEmpty(videoData) &&
        !isEmpty(videoData.listNotes) && (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={8}>
              <div className="video-homework mt-30">
                <h3 className="title-heading">Class Homework</h3>
                <ul className="homework-data">{populateClassMaterial()}</ul>
              </div>
            </Grid>
          </Grid>
        )
      )}
      <DigitalClassroomLayout />
    </React.Fragment>
  );
}
